import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Sun, Moon } from 'lucide-react';
import { trackThemeToggle } from '../lib/analytics';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  const handleToggle = () => {
    const nextTheme = theme === 'dark' ? 'light' : 'dark';
    toggleTheme();
    trackThemeToggle(nextTheme);
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className="flex items-center justify-center p-2 rounded-lg bg-slate-100 dark:bg-navy-850 border border-slate-300 dark:border-navy-700 text-slate-700 dark:text-slate-300 hover:text-gold-600 dark:hover:text-gold-400 transition-colors focus:outline-none focus:ring-1 focus:ring-gold-500 shadow-sm"
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      {theme === 'dark' ? (
        <Sun className="w-4 h-4 text-gold-400 transition-transform duration-200" />
      ) : (
        <Moon className="w-4 h-4 text-slate-700 transition-transform duration-200" />
      )}
    </button>
  );
};
